import React, { useContext } from 'react'

import { AppContext } from '../../../../contexts'

// Components
import SettingsPanel from '../SettingsPanel'
import YourTeam from '../YourTeam'
import OverviewPanel from '../OverviewPanel'

// Constants
import { TABS } from '../../../../constants/display'

const TabContent = () => {
  const { activeTab } = useContext(AppContext)

  switch (activeTab) {
    case TABS.OVERVIEW:
      return <OverviewPanel />
    case TABS.TEAM:
      return <YourTeam />
    case TABS.SETTINGS:
      return <SettingsPanel />
    default:
      return null
  }
}

export default TabContent
